/* SemanticUI-free pre-@plone/components */
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { logout, purgeMessages } from '@plone/volto/actions';
import { toast } from 'react-toastify';
import HeaderContainer from '../../../../components/HeaderContainer/HeaderContainer';
import * as VoltoSiteComponentes from 'volto-site-componentes';
import SkipLinks from '@plone/volto/components/theme/SkipLinks/SkipLinks';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronUp } from '@fortawesome/free-solid-svg-icons';

const Header = (props) => {
  const { pathname } = props;
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    const handler = (e) => {
      const target = e.target.closest && e.target.closest('#toolbar-logout');
      if (target) {
        e.preventDefault();
        if (typeof dispatch === 'function') {
          dispatch(logout());
          dispatch(purgeMessages());
          try {
            toast.dismiss('loggedOut');
          } catch (err) {}
        }
        if (history && typeof history.replace === 'function') {
          history.replace('/login');
        } else {
          window.location.assign('/login');
        }
      }
    };

    document.addEventListener('click', handler, true);
    return () => {
      document.removeEventListener('click', handler, true);
    };
  }, [dispatch, history]);

  return (
    <header className="header-wrapper">
      <SkipLinks />
      <VoltoSiteComponentes.BarraEstado />
      <VoltoSiteComponentes.BarraAcessibilidade />
      <HeaderContainer pathname={pathname} />
      <div style={{ textAlign: 'right' }}>
        <a aria-label="voltar ao topo" href="#main" className="btn-scroll">
          <FontAwesomeIcon icon={faChevronUp} />
        </a>
      </div>
    </header>
  );
};

Header.propTypes = {
  pathname: PropTypes.string.isRequired,
};

export default Header;
